import { LensBoxMode } from '@upright/ui/common/upright/core/impact-lens-profile/common/layout/types';
import styled from 'styled-components';
import { useCarouselContext } from '../../context';
import InterfaceDelete from '@upright/ui/icons/img/streamline-mini-line/interface-essential/add-remove-delete/interface-delete-1.svg';
import { BouColor } from '@upright/ui/common/generic/global/bou-colors';

export function ClearSelectionButton() {
  const context = useCarouselContext();
  const lens = context.lens;
  const boxMode = context.layout.boxMode;

  const showClearSelectionButton = (() => {
    if (context.options.hideClearSelectionButton) return false;
    if (boxMode === LensBoxMode.MODAL) return false;
    return !!lens.showClearSelectionButton?.(context.selectionState);
  })();

  if (!showClearSelectionButton) {
    return null;
  }

  const handleClick = () => {
    const newState = lens.getClearedSelectionState?.(context.selectionState);
    if (newState) {
      context.setSelectionState(newState);
    }
  };

  return (
    <Root onClick={handleClick}>
      <CrossIcon />
      Clear selection
    </Root>
  );
}

const Root = styled.button`
  display: flex;
  align-items: center;
  font-weight: bold;
  color: ${BouColor.TOOL_DANGER_RED};
`;

const CrossIcon = styled(InterfaceDelete)`
  stroke-width: 2px;
  height: 1em;
  width: 1em;
  margin-right: 0.4em;
`;
